<template>
    <div class="row-12" >
        <div v-show="browserAllow" class="col-12">
            <div v-show="projectDataInputNow">
                <section v-if="animationData" class="row-12">
                    <div class="col-6 col-sm-12">
                        <h3>Edycja projektu</h3>
                        <p >Aby przejść do kreatora animacji uzupełnij wymagane pola, a następnie kliknij przycisk znajdujący się na dole ekranu.</p>
                        <form @keydown.enter.prevent="dontSubmit($event)" class="form-align-right m-r-5">
                            <label>Temat projektu *</label>
                            <input type="text" v-model="animationData.name"
                                   placeholder="Temat, którego dotyczy ten projekt." autofocus required>
                            <folder-select ref="folders" v-model="animationData.folder"></folder-select>
                            <label>Opis projektu</label>
                            <textarea placeholder="Kilka słów o projekcie, może to być np. rozwinięcie tematu."
                                      v-model="animationData.description"></textarea>
                            <label>Wskazówki</label>
                            <textarea placeholder="Na co powinno się zwrócić uwagę w projekcie."
                                      v-model="animationData.tips"></textarea>
                            <label>Sprzęt sportowy</label>
                            <input-tag class="col-12" style="width: 100%; padding: 12px; border:none; margin: 5px 0;"
                                       placeholder="Sprzęt wymagany do przeprowadzenia projektu. Oddzielaj akcesoria klawiszem enter."
                                       :limit="10" :tags.sync="animationData.equipment"></input-tag>

                            <div class="row-12 col-12 w-100">
                                <div class="col-6">
                                    <label>Kategoria wiekowa</label>
                                    <input type="text" placeholder="Kategoria wiekowa zawodników."
                                           v-model="animationData.age_category"/>
                                </div>
                                <div class="col-6">
                                    <label>Obszar</label>
                                    <input type="text" placeholder="Ilość przestrzeni potrzebnej do przeprowadzenia projektu."
                                           v-model="animationData.field"/>
                                </div>
                            </div>

                            <small class="m-t-2 w-100">* pola wymagane</small>
                            <button @click.prevent="update(true)" style="margin-right: 5px;">Zapisz tylko dane</button>
                            <button @click.prevent="checkName">Przejdź do kreatora</button>
                        </form>
                    </div>
                    <div class="col-6 col-sm-12">
                        <h4>Twój aktualny projekt</h4>
                        <hr/>
                        <p>Pamiętaj, że każdy zapis wiąże się z ciężką pracą naszego serwera, aby wyrenderować jak najlepszą animację projektu. Prosimy o rozważną edycję danych.</p>
                        <div class="card">
                            <div class="card-image">
                                <img :src="animationData.main_image" :alt="animationData.name">
                            </div>
                            <div class="card-body">
                                <h4 class="m-t-1">{{animationData.name}}</h4>
                                <p v-if="animationData.description.length > 0"> {{strip(animationData.description)}} </p>
                                <p v-else> Ten projekt nie posiada opisu. Przejdź do edycji, aby go wprowadzić.</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div v-show="!projectDataInputNow" >
                <section class="row">
                    <div class="col-12">
                        <h3>Okno kreatora</h3>
                        <p>Tutaj możesz stworzyć szkic (pojedynczą klatkę) lub animację przedstawiającą Twój projekt.
                            Możesz również wrócić do edycji podstawowych danych.
                            <button class="button-p" @click="projectDataInputNow=true">Powrót do konfiguracji</button>
                        </p>
                        <div id="animator">
                            <div class="bck-second-d" id="animatorTopBar">
                                <div id="animatorLogo">
                                    <img src="../../assets/logoImg.svg" alt="Club Management Center - Animator">
                                </div>
                                <div id="animatorCategoryContainer">
                                    <div></div>
                                    <div>
                                        <div class="animatorCategoryItem" @click="showModal('#watermarkModal')"
                                             title="Znak wodny"><i class="fas fa-tag"></i></div>
                                        <div class="animatorCategoryItem" @click="showModal('#shortcodesModal')"
                                             title="Skróty klawiszowe"><i class="fas fa-keyboard"></i></div>
                                        <div class="animatorCategoryItem" data-categoryname="grid"
                                             title="Siatka pomocnicza"><i class="fas fa-th"></i></div>
                                        <div class="animatorCategoryItem" data-categoryname="fullscreen"
                                             title="Pełny ekran"><i class="fas fa-desktop"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div id="animatorMainContainer">
                                <div id="animatorLeftSidebar">
                                    <h1>Wybierz jedną z kategorii na pasku u góry.</h1>
                                </div>
                                <div id="animatorCanvasContainer">
                                    <div id="animatorNotifierContainer"></div>
                                    <div id="configuratorMenu" style="display: none;" class="bck-third form-darkner">
                                        <div id="configuratorMenuContent"></div>
                                        <div id="configuratorMenuActions">
                                            <div id="configuratorMenuActionsDynamicElements"></div>
                                            <label class="animatorMenuLabel">Akcje:</label>
                                            <button @click="animEngine.copySelected()">Kopiuj</button>
                                            <button @click="animEngine.deleteInConfiguratorMenu()">Usuń</button>
                                        </div>
                                    </div>
                                    <div id="animatorCanvas"></div>
                                </div>
                            </div>
                            <div id="animatorActionBar" class="bck-second-d">
                                <div id="animatorFrameOptionsContainer">
                                    <div class="animatorCategoryItem" @click="addFrame()" title="Dodaj klatkę"><i
                                            class="fas fa-plus"></i></div>
                                    <div class="animatorCategoryItem" @click="deleteFrame()" title="Usuń klatkę"><i
                                            class="fas fa-minus"></i></div>
                                    <div id="animatorFrameSlider">
                                        <div id="animatorFrameSliderLeftArrow" @click="moveFrameSlider('right')"><i
                                                class="fas fa-caret-left"></i></div>
                                        <div id="animatorFrameSliderContainer">
                                            <div class="animatorFrameItem animatorFrameVisibled animatorFrameActived">
                                                <span>1</span></div>
                                            <div class="animatorFrameItem"><span>2</span></div>
                                            <div class="animatorFrameItem"><span>3</span></div>
                                            <div class="animatorFrameItem"><span>4</span></div>
                                            <div class="animatorFrameItem"><span>5</span></div>
                                            <div class="animatorFrameItem"><span>6</span></div>
                                            <div class="animatorFrameItem"><span>7</span></div>
                                            <div class="animatorFrameItem"><span>8</span></div>
                                            <div class="animatorFrameItem"><span>9</span></div>
                                            <div class="animatorFrameItem"><span>10</span></div>
                                            <div class="animatorFrameItem"><span>11</span></div>
                                        </div>
                                        <div id="animatorFrameSliderRightArrow" @click="moveFrameSlider('left')"><i
                                                class="fas fa-caret-right"></i></div>
                                    </div>
                                    <div class="animatorCategoryItem" @click="animEngine.player.play()"><i
                                            class="fas fa-play"></i></div>
                                    <div class="animatorCategoryItem" @click="animEngine.player.pause()"><i
                                            class="fas fa-stop"></i></div>
                                </div>
                                <div id="animatorActionButtonContainer">
                                    <button @click="animEngine.getFramePng()">Pobierz aktualną klatkę</button>
                                    <button @click="update(false)">Zapisz i zakończ</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <div v-show="!browserAllow" class="col-12" style="width: 100%">
            <error-notifier
                    :type="errorType"
                    :title="errorTitle"
                    :message="errorMsq"
            />
        </div>
        <div class="modal" id="saveModal" >
            <div class="modal-header">
                {{!isSavedEnd ? 'Trwa zapis projektu.' : 'Projekt został zapisany.'}}
            </div>
            <div class="modal-body">
                <div class="searchLoader" v-if="!isSavedEnd">
                    <div class="span">
                        <div class="help"></div>
                    </div>
                </div>
                <div v-else >
                    <p v-if="!isSavedError" >Twój projekt został zapisany. Przechodzimy do renderowania animacji, za kilka minut powinna być dostępna. Możesz już przejść do listy projektów.</p>
                    <p v-else> Coś poszło nie tak. Spróbuj ponownie za chwilkę. </p>
                </div>
            </div>
            <div class="modal-action flex-align-right">
                <button v-if="!isSavedError" @click="saveEnd()">Lista projektów.</button>
                <button v-else @click="hideModal('#saveModal')">Zamknij</button>
            </div>
        </div>
        <div class="modal" id="shortcodesModal">
            <div class="modal-header">Skróty klawiszowe</div>
            <div class="modal-body">
                <ul>
                    <li><code>CTRL + A</code> - Zaznaczenie wszystkich elementów</li>
                    <li><code>SHIFT + lewy przycisk myszy</code> - Zaznaczenie kolejnego elementu</li>
                    <li><code>prawy przycisk myszy</code> - Konfiguracja zaznaczonych elementów</li>
                    <li><code>CTRL + C</code> - Kopiowanie zaznaczonych elementów</li>
                    <li><code>CTRL + V</code> - Wklejanie skopiowanych elementów</li>
                    <li><code>DELETE</code> - Usuwanie zaznaczonych elementów</li>
                    <li><code>ESC</code> - Odznaczenie zaznaczonych elementów </li>
                </ul>
            </div>
            <div class="modal-action flex-align-right">
                <button @click="hideModal('#shortcodesModal')">Zamknij</button>
            </div>
        </div>
        <div class="modal" id="watermarkModal">
            <div class="modal-header">Znak wodny pomoże Ci zabezpieczyć Twoją pracę</div>
            <div class="modal-body">
                <p class="text-a-c" v-if="watermarkList.length !== 0"> Kliknij w wybrany, aby użyć.</p>
                <div class="watermarkList m-t-5">
                    <div class="watermark" v-for="watermark in watermarkList">
                        <div class="watermark-remove" @click="removeWatermark(watermark.id)">
                            <i class="i-cross"></i>
                        </div>
                        <img :src="watermark.image" :alt="watermark.id" @click="selectWatermark(watermark,$event)">
                    </div>
                    <div v-if="watermarkList.length === 0">
                        <small class="w-100 text-a-c">Nie posiadasz jeszcze żadnych znaków wodnych. Dodaj jeden, korzystając z przycisku poniżej.</small>
                    </div>
                </div>
                <div class="row-12 w-100 m-y-5" >
                    <div class="col-6 col-sm-12 center-flex-a cent m-t-2">
                        <div class="input-file-container ">
                            <input class="input-file" id="new_watermark" type="file" accept="image/png, image/jpeg">
                            <label tabindex="0" for="new_watermark" class="input-file-trigger">Wybierz plik...</label>
                        </div>
                        <p class="file-return"></p>
                    </div>
                    <div class="col-6 col-sm-12">
                        <p class="m-b-0">Możesz dodać nowy znak wodny</p>
                        <small>Wymagania: format - <b>png, jpg</b> rozmiar - <b>maks. 2mb</b></small>
                    </div>
                </div>
                <hr>
                <div class="row-12">
                    <div class="col-5 col-sm-12">
                        <form style="padding-right: 5px;">
                            <div class="col-6 display-flex m-b-5">
                                <label class="w-100 m-b-2">Pozycja w animacji</label>
                                <select class="w-100" v-model="watermark.position" required>
                                    <option value="top">Góra środek</option>
                                    <option value="top-left">Lewy górny róg</option>
                                    <option value="top-right">Prawy górny róg</option>
                                    <option value="center">Środek</option>
                                    <option value="bottom">Dół środek</option>
                                    <option value="bottom-left">Lewy dolny róg</option>
                                    <option value="bottom-right">Prawy dolny róg</option>
                                </select>
                            </div>
                            <div class="col-6 display-flex">
                                <label class="w-100">Skala znaku wodnego ( {{watermark.scale}} )</label>
                                <input v-model="watermark.scale" type="range" min="0.1" max="2" step="0.1"
                                       placeholder="Ustawia skale dla Twojego obrazu" autofocus required>
                            </div>
                            <div class="col-12 display-flex p-t-3 w-100">
                                <label class="w-100">Przeźroczystość znaku ( {{watermark.opacity}} )</label>
                                <input v-model="watermark.opacity" type="range" min="0.1" max="1" step="0.1" required>
                            </div>
                        </form>
                    </div>
                    <div class="col-7 col-sm-12">
                        <small class="text-a-c center-flex-a" v-show="!watermark.image">Nie wybrałeś jeszcze, żadnego znaku wodnego. Wybierz klikając w wybrany, aby zobaczyć podgląd.</small>
                        <div id='waterPreviewCanvas' class="center-flex-a" v-show="watermark.image">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" style="margin-right: 5px;" @click="hideModal('#watermarkModal')">Anuluj</button>
                <button class="button-outline-p" style="margin-right: 5px;" @click="removeWatermarkFromAnim">Usuń aktualny</button>
                <button @click="addWatermarkToAnim">Dodaj wybrany</button>
            </div>
        </div>
    </div>
</template>

<script>
    import animEngine from '../../additionalClass/Animator/AnimatorEngine'
    import ErrorNotifier from '../../components/ErrorFullNotifier'
    import InputTag from 'vue-input-tag'
    import FolderSelect from '../../components/FolderSelect'

    export default {
        components: {
            'error-notifier': ErrorNotifier, InputTag,
            'folder-select': FolderSelect
        },
        data: function(){
            return {
                watermark:{
                    image: '',
                    scale: 1,
                    opacity: 1,
                    position: 'center'
                },
                watermarkList: [],
                waterPreviewFrame: null,
                animEngine: animEngine,
                saveProjectModal: false,
                isSavedEnd: false,
                animUrl: '',
                animationData: {
                    name: '',
                    description: '',
                    equipment: [],
                    field: '',
                    folder: '',
                    age_category: '',
                    tips: '',
                },
                isSavedError: false,
                projectDataInputNow: true,
                isOpen: false,
                shortcodesModal: false,
                browserAllow: this.checkBrowserWindowCompatibility(),
                errorType: 'error',
                errorTitle: 'Zbyt mała rozdzielczość ekranu.',
                errorMsq: 'Niestety rozdzielczość Twojego ekranu nie pozwala na pełne wykorzystanie naszego kreatora. Prosimy otwórz kreator na większym urządzeniu, aby móc w pełni wykorzystać naszą aplikację.'
            }
        },
        watch:{
            'watermark.scale': function (newVal, oldVal){
                if(this.watermark.image) this.drawWatermarkImage();
            },
            'watermark.opacity': function(newVal, oldVal){
                if(this.watermark.image) this.drawWatermarkImage();
            },
            'watermark.position': function(newVal, oldVal){
                if(this.watermark.image) this.drawWatermarkImage();
            }
        },
        methods:{
            saveEnd(){
                this.hideModal('#saveModal');
                this.saveProjectModal = false;
                this.$router.push('/practice');
            },
            update(onlyData = null){
                this.showModal('#saveModal');
                this.isSavedError = false;
                if(!onlyData) onlyData = false;
                animEngine.update(this.animationData, onlyData )
                    .then((response)=>{
                        this.isSavedEnd = !!response;
                        this.saveEnd();
                    })
                    .catch(()=>{
                        this.isSavedError = true;
                        this.hideModal('#saveModal');
                        this.saveProjectModal = false;
                        notify.createNotifier("Coś poszło nie tak, spróbuj jeszcze raz.", "danger", 3000);
                    })
            },
            checkName(){
                try {
                    let valid = new Validator({
                        "nazwa animacji": this.animationData.name,
                        "folder": this.animationData.folder
                    });
                    valid.get("nazwa animacji").length(3, 255);
                    valid.get("folder").isNotNull()
                }catch (e) {
                    return;
                }
                this.projectDataInputNow = false;
                this.init();
            },
            checkBrowserWindowCompatibility(){
                let retValue = true;

                if( ($( window ).width() < 1000 && $( window ).height() < 1000) ){
                    retValue = false;
                    this.errorType = 'error';
                    this.errorMsq = 'Niestety rozdzielczość Twojego ekranu nie pozwala na pełne wykorzystanie naszego kreatora. Prosimy otwórz kreator na większym urządzeniu, aby móc w pełni wykorzystać naszą aplikację.'
                }

                return retValue;
            },
            copySelected(){
                animEngine.copySelected();
            },
            strip(html)
            {
                let tmp = document.createElement("DIV");
                tmp.innerHTML = html;
                return tmp.textContent || tmp.innerText || "";
            },
            addFrame(){
                let index = this.addNewFrameItem();
                this.calculateFrame();
                this.selectFrame(index);
                this.updateFrameSlider();
            },
            deleteFrame(){
                if($('.animatorFrameVisibled').length === 1) return;
                else if(!$('.animatorFrameVisibled').eq($('.animatorFrameVisibled').length-1).hasClass('animatorFrameActived')) return;
                let frame = $('.animatorFrameVisibled').length-1;
                animEngine.deleteFrame(frame, ()=>{
                    $('.animatorFrameVisibled').eq($('.animatorFrameVisibled').length-1).remove();
                    this.selectFrame(frame-1);
                    if($('.animatorFrameItem').length < 11 ) $('#animatorFrameSliderContainer').append(`<div class="animatorFrameItem"></div>`);
                    this.updateFrameSlider();
                });
            },
            selectFrame(index){
                if(!$('.animatorFrameItem').eq(index).hasClass('animatorFrameVisibled')) return;
                animEngine.setFrame(index);

                $('.animatorFrameActived').each(function(){
                    $(this).removeClass('animatorFrameActived');
                });
                $('.animatorFrameItem').eq(index).addClass('animatorFrameActived');
            },
            resizeLayout(){
                animEngine.resize();
            },
            categoryClick(element,actionName){

                if(!actionName) return;

                switch(actionName){
                    case 'fullscreen':
                    case 'grid':
                        let ret = animEngine.optionToggle(actionName);
                        if(ret) element.toggleClass('animatorActivedCategory');
                        return;
                }

                $("#animatorLeftSidebar > h1").fadeOut(200);

                $('#animatorCategoryContainer > div:nth-child(1) > .animatorCategoryItem').each(function(element){
                    $( this ).removeClass('animatorActivedCategory');
                });

                element.addClass('animatorActivedCategory');
                animEngine.changeCategory(element.data('categoryname'));

                $('#animatorLeftSidebar > div').each(function(element){
                    if($( this ).data('catname') === actionName){
                        $( this ).css('position','relative');
                        $( this ).stop().fadeIn(200);
                    }else{
                        $( this ).css('position','absolute');
                        $( this ).stop().fadeOut(200,'swing',()=>{
                            $( this ).css('position','relative');
                        });
                    }
                });

                $('.animatorItemInGroup').each(function(element){
                    $( this ).removeClass('animatorItemInGroupActived');
                });

                animEngine.changeCategoryItem('none');
            },
            moveFrameSlider(destination){
                let count = $('.animatorFrameItem').length;
                let matrix = $('.animatorFrameItem').eq(0).css('transform');
                let matchX = matrix.replace("matrix(",'');
                matchX = matchX.replace(")",'');
                matchX = matchX.split(',');
                let maxSlide = (count - 6) * -27;
                let newX = 0;

                newX = parseInt(matchX[4]) + (destination==='left'?-54:54);

                if(newX>0) newX = 0;
                else if(newX<maxSlide) newX = maxSlide;

                $('.animatorFrameItem').each(function(){
                    $(this).css("transform",`translateX(${newX}px)`);
                });
            },
            calculateFrame(){
                let count = 1;
                $('.animatorFrameItem').each(function(){
                    $(this).html(`<span>${count}</span>`);
                    count++;
                });
            },
            addNewFrameItem(){
                if($('.animatorFrameItem').length == $('.animatorFrameVisibled').length){
                    $('#animatorFrameSliderContainer').append(`<div class="animatorFrameItem"></div>`);
                }

                for(let i=0; i<$('.animatorFrameItem').length;i++){
                    if(!$('.animatorFrameItem').eq(i).hasClass('animatorFrameVisibled')){
                        $('.animatorFrameItem').eq(i).addClass('animatorFrameVisibled');
                        return i;
                    }
                }
            },
            updateFrameSlider(){
                let count = $('.animatorFrameItem').length;
                let index = $('.animatorFrameActived').index();
                let newX = (index - 5) * -27;
                let maxSlide = (count - 11) * -27;

                if(newX>0) newX = 0;
                else if(newX<maxSlide) newX = maxSlide;

                $('.animatorFrameItem').each(function(){
                    $(this).css("transform",`translateX(${newX}px)`);
                });
            },
            loadAnimatorData(){
                // TODO inne sporty - jesli chcemy wystarczy w tym miejscu dac inny konfig
                return fetch('componentResources/animator/animatorItemList.json')
                    .then(r=>r.json())
                    .then((config)=>{
                        config.category.forEach((item)=>{
                            let stringItem = `<div class="animatorCategoryItem" title="${item.tooltip}"  data-categoryname="${item.name}" " ><img class="animatorCategoryImg" src="componentResources/animator/football/categories/${item.icon}.svg"/></div>`;
                            $('#animatorCategoryContainer > div:nth-child(1)').append(stringItem);
                            stringItem = `<div class="animatorCatIt" style="display:none; width:100%;" data-catname="${item.name}">`;
                            item.items.forEach((group)=>{
                                stringItem += `<div class="animatorItemGroup"><h5>${group.name}</h5><hr/><div class="animatorItemInGroupContainer">`;

                                switch(group.type){
                                    case "img":
                                        group.items.forEach((groupItem)=>{
                                            stringItem += `<div class="animatorItemInGroup ${group.class}" title="${groupItem.tooltip}" data-itemname="${groupItem.data}"><img src="${groupItem.img}"></div>`;
                                        });
                                        break;
                                    case "switch":
                                        group.items.forEach((groupItem)=>{
                                            stringItem += `<div class="animatorSwitchInGroup" id="${groupItem.id}">
                                                                <label>${groupItem.name}</label>
                                                                <button class="button-free-p switch-${groupItem.id}">TAK</button>
                                                                <button class="switch-${groupItem.id}">NIE</button>
                                                            </div>`;
                                        });
                                        break ;
                                }

                                stringItem += `</div></div>`;
                            });
                            if(item.items.length === 0){
                                stringItem += `<h1>Brak elementów do wyświetlenia</h1>`;
                            }
                            stringItem += `</div>`;
                            $('#animatorLeftSidebar').append(stringItem);
                            tippy('[title]',{
                                placement: 'bottom'
                            });
                        });
                        this.categoryClick($('.animatorCategoryItem').first(),$('.animatorCategoryItem').first().data('categoryname'));
                    });
            },
            itemInCategoryClick(element,actionName){
                if( element.hasClass('animatorItemInGroupActived') ){
                    element.removeClass('animatorItemInGroupActived');
                    animEngine.changeCategoryItem('none');
                }else{
                    $('.animatorItemInGroup').each(function(element){
                        $( this ).removeClass('animatorItemInGroupActived');
                    });

                    element.addClass('animatorItemInGroupActived');
                    animEngine.changeCategoryItem(actionName);
                }

            },
            init( data = null ){
                if(this.isOpen) return;
                this.isOpen = true;

                $(document).off('contextmenu','#animatorCanvas');
                $(document).on('contextmenu','#animatorCanvas',()=>{
                    return false;
                });

                $(document).off('contextmenu','#configuratorMenu');
                $(document).on('contextmenu','#configuratorMenu',()=>{
                    return false;
                });

                this.loadAnimatorData().then((r)=>{
                    let self = this;
                    if(data) animEngine.build(false, data);
                    else  animEngine.build();

                    $(document).off('click touch','.animatorFrameItem');
                    $(document).on('click touch','.animatorFrameItem',function(){
                        self.selectFrame($(this).index());
                    });

                    $(document).off('click touch','#animatorCategoryContainer .animatorCategoryItem');
                    $(document).on('click touch','#animatorCategoryContainer .animatorCategoryItem',function(){
                        self.categoryClick($(this),$(this).data('categoryname'));
                    });

                    $(document).off('click touch','.animatorItemInGroup');
                    $(document).on('click touch','.animatorItemInGroup',function(){
                        self.itemInCategoryClick($(this),$(this).data('itemname'));
                    });

                    $(window).on('resize',this.resizeLayout);
                });
            },
            destroy(){
                if(!this.isOpen) return;
                this.isOpen = false;
                $(window).off('resize',this.resizeLayout);
                $(document).off('click touch','.animatorItemInGroup');
                $(document).off('click touch','#animatorCategoryContainer .animatorCategoryItem');
                $(document).off('click touch','.animatorFrameItem');
                $(document).off('contextmenu','#configuratorMenu');
                $(document).off('contextmenu','#animatorCanvas');
                animEngine.destroy();
            },
            dontSubmit(event) {
                let s = event.target.value;
                event.target.value = s + "\n";
                return false;
            },
            selectWatermark(watermark,e){
                this.watermark.image = watermark.image;
                $('.watermark').removeClass('actived');
                if($(e.target).hasClass('actived')) $(e.target).addClass('actived');
                else $(e.target).closest('.watermark').addClass('actived');
                this.drawWatermarkImage();
            },
            drawWatermarkImage(){
                let waterImage = this.waterPreviewFrame.stage.getChildByName('watermark');
                if(waterImage){
                    this.waterPreviewFrame.stage.removeChild(waterImage);
                }

                this.watermarkBitmap = new zim.Bitmap(this.watermark.image);
                this.watermarkBitmap.name = 'watermark';
                this.watermarkBitmap.scale = this.watermark.scale;
                this.watermarkBitmap.alpha = this.watermark.opacity;

                let actualWidth = this.waterPreviewFrame.stage.width / this.waterPreviewFrame.stage.scaleX;
                let actualHeight = this.waterPreviewFrame.stage.height / this.waterPreviewFrame.stage.scaleY;

                switch (this.watermark.position) {
                    case "top-left":
                        this.watermarkBitmap.x = 20;
                        this.watermarkBitmap.y = 0;
                        break;
                    case "top":
                        this.watermarkBitmap.x = (actualWidth / 2.0) - this.watermarkBitmap.width / 2.0;
                        this.watermarkBitmap.y = 0;
                        break;
                    case "center":
                        this.watermarkBitmap.x = (actualWidth / 2.0) - this.watermarkBitmap.width / 2.0;
                        this.watermarkBitmap.y = (actualHeight / 2.0) - this.watermarkBitmap.height / 2.0;
                        break;
                    case "top-right":
                        this.watermarkBitmap.x = actualWidth - this.watermarkBitmap.width - 20;
                        this.watermarkBitmap.y = 0;
                        break;
                    case "bottom-left":
                        this.watermarkBitmap.x = 20;
                        this.watermarkBitmap.y = actualHeight - this.watermarkBitmap.height;
                        break;
                    case "bottom":
                        this.watermarkBitmap.x = (actualWidth / 2.0) - this.watermarkBitmap.width / 2.0;
                        this.watermarkBitmap.y = actualHeight - this.watermarkBitmap.height;
                        break;
                    case "bottom-right":
                        this.watermarkBitmap.x = actualWidth - this.watermarkBitmap.width - 20;
                        this.watermarkBitmap.y = actualHeight - this.watermarkBitmap.height;
                        break;
                }

                this.waterPreviewFrame.stage.addChild(this.watermarkBitmap);
                this.waterPreviewFrame.stage.update();
            },
            addWatermark(img){
                axios.post('watermark',{image:img})
                    .then((response)=>{
                        this.watermarkList.push(response.data);
                        notify.createNotifier("Znak wodny dodany", "success", 3000);
                    })
            },
            removeWatermarkFromAnim(){
                let waterImage = this.waterPreviewFrame.stage.getChildByName('watermark');
                if(waterImage){
                    this.waterPreviewFrame.stage.removeChild(waterImage);
                }
                $('.watermark').removeClass('actived');
                animEngine.changeWatermark(null);
                this.hideModal('#watermarkModal');
            },
            addWatermarkToAnim(){
                animEngine.changeWatermark(this.watermark);
                this.hideModal('#watermarkModal');
                notify.createNotifier("Znak wodny ustawiony", "success", 3000);
            },
            removeWatermark(id){
                axios.delete(`watermark/${id}`)
                    .then((response)=>{
                        this.watermarkList = this.watermarkList.filter((water)=>{
                            return water.id !== id;
                        });
                        notify.createNotifier("Znak wodny usunięty", "success", 3000);
                    })
            },
            createWaterPreview(){
                this.waterPreviewFrame = new zim.Frame("waterPreviewCanvas", 386, 231,'#CCC');
                this.waterPreviewFrame.on("ready",()=>{
                    let stage = this.waterPreviewFrame.stage;
                    let scale = 386 / 1812;
                    stage.setTransform(0,0,scale,scale);
                    setTimeout(()=>{
                        let self = this;
                        this.waterPreviewFrame.on("complete", app);
                        this.waterPreviewFrame.loadAssets(["light_grass_bottom_half.jpg"], "componentResources/animator/football/pitch/");

                        function app() {
                            let image = self.waterPreviewFrame.asset("light_grass_bottom_half.jpg");
                            image.name = 'field';
                            image.x = image.y = 0;
                            stage.addChildAt(image,0);
                            stage.update();
                        }
                    },500);
                });
            }
        },
        mounted: function(){
            $(document).ready(()=>{

                $(document).on('change', '#new_watermark', () => {
                    let reader = new FileReader();
                    reader.readAsDataURL($('#new_watermark')[0].files[0]);
                    reader.onload = () => {
                        $('#new_watermark').val("");
                        this.addWatermark(reader.result);
                    };
                });

                axios.get("watermark")
                    .then((response)=>{
                        this.watermarkList = response.data;
                    });

                $(window).on('resize',()=>{
                    this.browserAllow = this.checkBrowserWindowCompatibility();
                });
                $(document).off("click",".animatorSwitchInGroup button");
                $(document).on("click",".animatorSwitchInGroup button",function(){
                    let parentId = $(this).parent().attr('id');
                    $("#"+parentId).find('button').each(function(){
                        $(this).addClass("button-free-p");
                    });
                    $(this).removeClass("button-free-p");
                })

                axios.get(`animations/${this.$route.params.id}`)
                    .then((response)=>{
                        this.animationData = response.data;
                        this.animationData.equipment = this.animationData.equipment.length > 3 ? JSON.parse(this.animationData.equipment) : [];
                        const watermark = (response.data.watermark && response.data.watermark.length > 3) ? JSON.parse(response.data.watermark) : null;
                        this.init({watermark: watermark, name: response.data.name, pathField:response.data.path_field , frameData: JSON.parse(response.data.frame_data), objectInAnimation: JSON.parse(response.data.object_in_animation)});
                        this.animationData.folder = this.animationData.folder_id;
                        setTimeout(()=>{
                            this.$refs.folders.select(this.animationData.folder_id);
                        },500);
                    });

                this.createWaterPreview();
            });
        },
        beforeDestroy: function(){
            $(window).off('resize');
            delete this.animationData;
            this.animationData = null;
            if(this.localSaveInterval) clearInterval(this.localSaveInterval);
            this.destroy();
        }
    }
</script>

<style>
    .vue-input-tag-wrapper .input-tag{
        color: #fff !important;
        background-color: #6e52a8 !important;
        border: none !important;
        padding: 5px !important;
    }

    .vue-input-tag-wrapper .input-tag .remove{
        color: #fff !important;
        padding-left: 5px;
    }
</style>